import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Home.css';
import { getAllProducts } from '../../services/firestoreService';

const Home = () => {
  const [marketPrices, setMarketPrices] = useState([]);

  // Load products from Firebase only
  useEffect(() => {
    // Clear old localStorage cache once per session
    const hasCleared = sessionStorage.getItem('productsCleared');
    if (!hasCleared) {
      localStorage.removeItem('adminProducts');
      sessionStorage.setItem('productsCleared', 'true');
      console.log('✅ Cleared old products cache');
    }

    const loadProducts = async () => {
      try {
        console.log('Loading products from Firebase...');
        const products = await getAllProducts();
        const formattedPrices = products.map(product => ({
          id: product.id,
          name: `${product.name} (${product.englishName})`,
          price: product.currentPrice
        }));
        setMarketPrices(formattedPrices);
        console.log(`Loaded ${products.length} products from Firebase`);
      } catch (error) {
        console.error('Error loading products from Firebase:', error);
      }
    };

    // Load initially
    loadProducts();

    // Refresh products every 10 seconds to get latest data
    const interval = setInterval(loadProducts, 10000);

    return () => {
      clearInterval(interval);
    };
  }, []);

  return (
    <div className="home-page">
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-content">
          <h1>ಮುಕ್ತಂಕಾರ ಟ್ರೇಡರ್ಸ್ ಕೋಟ್ಯಾಳಿಗೆ ಸ್ವಾಗತ</h1>
          <div className="hero-market-prices-cards">
            {marketPrices.map(item => (
              <div key={item.id} className="hero-price-card">
                <span className="product-name">{item.name}</span>
                <div className="price-details">
                  <i className="fas fa-seedling"></i>
                  <span className="price">₹{item.price.toFixed(0)}/quintal</span>
                </div>
              </div>
            ))}
          </div>
          <Link to="/products" className="view-all-prices-button">
            View All Prices <i className="fas fa-arrow-right"></i>
          </Link>
        </div>
      </section>

      {/* Market Prices Section */}
      

      {/* Services Section */}
      <section className="services">
        <div className="container">
          <h2>ಬೇಳೆ ಮಾರುವ ವಿಧಾನ</h2>
          <div className="service-grid">
            <div className="service-card">
              <i className="fas fa-phone"></i>
              <h3>ಭೇಟಿ ಸೇವೆ 9902671238</h3>
              <p>ನೀವು ನಮ್ಮ ಸಂಖ್ಯೆಗೆ ಕರೆ ಮಾಡಿದರೆ, ನಾವು ನಿಮ್ಮ ಹೊಲಕ್ಕೆ ಭೇಟಿ ನೀಡುತ್ತೇವೆ.</p>
            </div>
            <div className="service-card">
              <i className="fas fa-microscope"></i>
              <h3>ಗುಣಮಟ್ಟ ಪರಿಶೀಲನೆ</h3>
              <p>ನಾವು ಗುಣಮಟ್ಟ ಪರಿಶೀಲನೆ ಮಾಡುತ್ತೇವೆ ಮತ್ತು ಮೊದಲಿಗೆ ಸ್ವಲ್ಪ ಮೊತ್ತವನ್ನು ಮುಂಗಡವಾಗಿ ಪಾವತಿಸುತ್ತೇವೆ.</p>
            </div>
            <div className="service-card">
              <i className="fas fa-truck"></i>
              <h3>ಸಾಗಣೆ ಸೇವೆ</h3>
              <p>ನಮ್ಮ ಲಾರಿ ಅಥವಾ ವಾಹನ ನಿಮ್ಮ ಹೊಲಕ್ಕೆ ಬಂದು ಸರಿಯಾದ ತೂಕ ತೂಗಿ ಉತ್ಪನ್ನವನ್ನು ಕೊಂಡೊಯ್ಯುತ್ತದೆ.</p>
            </div>
            <div className="service-card">
              <i className="fas fa-money-bill-wave"></i>
              <h3>ಹಣ</h3>
              <p>ಎರಡು ದಿನಗಳ ಒಳಗೆ ನಿಮ್ಮ ಖಾತೆಗೆ ಸಂಪೂರ್ಣ ಹಣ ಜಮೆ ಮಾಡಲಾಗುತ್ತದೆ.</p>
            </div>
          </div>
        </div>
      </section>

      {/* How to Sell Section */}
      

      {/* Features Section */}
      <section className="features">
        <div className="container">
          <div className="feature-content">
            <div className="feature-text">
              <h2>ಏಕೆ ನಮ್ಮನ್ನು ಆಯ್ಕೆ ಮಾಡಬೇಕು?</h2>
              <ul className="feature-list">
                <li>
                  <i className="fas fa-check-circle"></i>
                  <span>25+ ವರ್ಷಗಳ ಕೈಗಾರಿಕಾ ಅನುಭವ</span>
                </li>
                <li>
                  <i className="fas fa-check-circle"></i>
                  <span>ನಿಮ್ಮ ಬೇಳೆಗೆ ಉತ್ತಮ ಮಾರುಕಟ್ಟೆ ಬೆಲೆ ಪಡೆಯಿರಿ</span>
                </li>
                <li>
                  <i className="fas fa-check-circle"></i>
                  <span>ನಮ್ಮ ಲಾರಿ ಅಥವಾ ವಾಹನ ನಿಮ್ಮ ಹೊಲಕ್ಕೆ ಬಂದು ಸರಿಯಾದ ತೂಕ ತೂಗಿ ಉತ್ಪನ್ನವನ್ನು ಕೊಂಡೊಯ್ಯುತ್ತದೆ.</span>
                </li>
                <li>
                  <i className="fas fa-check-circle"></i>
                  <span>ಎರಡು ದಿನಗಳ ಒಳಗೆ ನಿಮ್ಮ ಖಾತೆಗೆ ಸಂಪೂರ್ಣ ಹಣ ಜಮೆ ಮಾಡಲಾಗುತ್ತದೆ.</span>
                </li>
                <li>
                  <i className="fas fa-check-circle"></i>
                  <span>24/7 ಗ್ರಾಹಕ ಬೆಂಬಲ</span>
                </li>
              </ul>
              <Link to="/about" className="primary-btn">
                ಇನ್ನಷ್ಟು ತಿಳಿಯಿರಿ
              </Link>
            </div>
            <div className="feature-image">
              <img src="/assets/images/agri.png" alt="Our Services" />
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="testimonials">
        <div className="container">
          <h2>ನಮ್ಮ ಪಾಲುದಾರರ ಅಭಿಪ್ರಾಯಗಳು</h2>
          <div className="testimonial-grid">
            <div className="testimonial-card">
              <div className="testimonial-content">
                <p>
                  "ಮುಕ್ತಂಕಾರ ಟ್ರೇಡರ್ಸ್ ನಮ್ಮ ಮಾರುಕಟ್ಟೆ ವಿಸ್ತರಣೆಗೆ ಸಹಾಯ ಮಾಡಿದ್ದಾರೆ. ಅವರ ವೃತ್ತಿಪರ ವಿಧಾನ ಮತ್ತು ನ್ಯಾಯೋಚಿತ ಬೆಲೆಗಳು ಅವರನ್ನು ನಮ್ಮ ಆದ್ಯತೆಯ ವ್ಯಾಪಾರ ಪಾಲುದಾರರನ್ನಾಗಿ ಮಾಡಿವೆ."
                </p>
              </div>
              <div className="testimonial-author">
                <img src="/assets/images/agri.png" alt="Farmer" />
                <div>
                  <h4>ರಾಜೇಶ್ ಕುಮಾರ್</h4>
                  <span>ರೈತ, ಕರ್ನಾಟಕ</span>
                </div>
              </div>
            </div>
            <div className="testimonial-card">
              <div className="testimonial-content">
                <p>
                  "ಉತ್ಪನ್ನಗಳ ಗುಣಮಟ್ಟ ಮತ್ತು ಸಮಯಕ್ಕೆ ತಲುಪಿಸುವಿಕೆ ನಮ್ಮ ವ್ಯಾಪಾರ ಸಂಬಂಧವನ್ನು ಮುಕ್ತಂಕಾರ ಟ್ರೇಡರ್ಸ್ ಜೊತೆ ಯಶಸ್ವಿಯಾಗಿ ಮಾಡಿವೆ."
                </p>
              </div>
              <div className="testimonial-author">
                <img src="/assets/images/agri.png" alt="Trader" />
                <div>
                  <h4>ಪ್ರಿಯಾ ಶರ್ಮಾ</h4>
                  <span>ವ್ಯಾಪಾರಿ, ಮಹಾರಾಷ್ಟ್ರ</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Core Values Section */}
      <section className="core-values">
        <div className="container">
          <h2>ನಮ್ಮ ಮೂಲಭೂತ ಮೌಲ್ಯಗಳು</h2>
          <div className="values-grid">
            <div className="value-card">
              <i className="fas fa-handshake"></i>
              <h3>ವಿಶ್ವಾಸ</h3>
              <p>ನಾವು ಪ್ರಾಮಾಣಿಕತೆ ಮತ್ತು ಪಾರದರ್ಶಕತೆಯ ಮೇಲೆ ನಮ್ಮ ವ್ಯಾಪಾರವನ್ನು ನಿರ್ಮಿಸಿದ್ದೇವೆ.</p>
            </div>
            <div className="value-card">
              <i className="fas fa-award"></i>
              <h3>ಗುಣಮಟ್ಟ</h3>
              <p>ಉತ್ತಮ ಗುಣಮಟ್ಟದ ಉತ್ಪನ್ನಗಳು ಮತ್ತು ಸೇವೆಗಳನ್ನು ಒದಗಿಸುವುದು ನಮ್ಮ ಗುರಿ.</p>
            </div>
            <div className="value-card">
              <i className="fas fa-balance-scale"></i>
              <h3>ನ್ಯಾಯೋಚಿತ ಬೆಲೆ</h3>
              <p>ರೈತರಿಗೆ ಮತ್ತು ವ್ಯಾಪಾರಿಗಳಿಗೆ ನ್ಯಾಯೋಚಿತ ಮತ್ತು ಸ್ಪರ್ಧಾತ್ಮಕ ಬೆಲೆಗಳನ್ನು ನೀಡುತ್ತೇವೆ.</p>
            </div>
            <div className="value-card">
              <i className="fas fa-users"></i>
              <h3>ಗ್ರಾಹಕ ಸೇವೆ</h3>
              <p>ನಮ್ಮ ಗ್ರಾಹಕರ ತೃಪ್ತಿ ನಮ್ಮ ಮೊದಲ ಆದ್ಯತೆ.</p>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="faq-section">
        <div className="container">
          <h2>ಪದೇ ಪದೇ ಕೇಳಲಾಗುವ ಪ್ರಶ್ನೆಗಳು</h2>
          <div className="faq-grid">
            <div className="faq-item">
              <div className="faq-question">
                <i className="fas fa-question-circle"></i>
                <h3>ನೀವು ಯಾವ ಉತ್ಪನ್ನಗಳನ್ನು ಖರೀದಿಸುತ್ತೀರಿ?</h3>
              </div>
              <p className="faq-answer">
                ನಾವು ತೂರು, ಹೆಸರು, ಕಡಲೆ ಮತ್ತು ಇತರ ಬೇಳೆ ಪ್ರಭೇದಗಳನ್ನು ಖರೀದಿಸುತ್ತೇವೆ. ಉತ್ತಮ ಗುಣಮಟ್ಟದ ಉತ್ಪನ್ನಗಳಿಗೆ ನಾವು ಉತ್ತಮ ಬೆಲೆ ನೀಡುತ್ತೇವೆ.
              </p>
            </div>

            <div className="faq-item">
              <div className="faq-question">
                <i className="fas fa-question-circle"></i>
                <h3>ಪಾವತಿ ಎಷ್ಟು ಸಮಯದಲ್ಲಿ ಆಗುತ್ತದೆ?</h3>
              </div>
              <p className="faq-answer">
                ಉತ್ಪನ್ನವನ್ನು ತೂಗಿ ಕೊಂಡೊಯ್ದ ನಂತರ ಎರಡು ದಿನಗಳ ಒಳಗೆ ನಿಮ್ಮ ಖಾತೆಗೆ ಸಂಪೂರ್ಣ ಹಣ ಜಮೆ ಮಾಡಲಾಗುತ್ತದೆ.
              </p>
            </div>

            <div className="faq-item">
              <div className="faq-question">
                <i className="fas fa-question-circle"></i>
                <h3>ಸಾಗಣೆ ವೆಚ್ಚ ಯಾರು ಭರಿಸುತ್ತಾರೆ?</h3>
              </div>
              <p className="faq-answer">
                ನಮ್ಮ ಲಾರಿ ಅಥವಾ ವಾಹನ ನಿಮ್ಮ ಹೊಲಕ್ಕೆ ಬಂದು ಉತ್ಪನ್ನವನ್ನು ಕೊಂಡೊಯ್ಯುತ್ತದೆ. ಸಾಗಣೆ ವೆಚ್ಚವನ್ನು ನಾವು ಭರಿಸುತ್ತೇವೆ.
              </p>
            </div>

            <div className="faq-item">
              <div className="faq-question">
                <i className="fas fa-question-circle"></i>
                <h3>ಗುಣಮಟ್ಟ ಪರಿಶೀಲನೆ ಹೇಗೆ ಮಾಡಲಾಗುತ್ತದೆ?</h3>
              </div>
              <p className="faq-answer">
                ನಮ್ಮ ತಜ್ಞರು ನಿಮ್ಮ ಹೊಲಕ್ಕೆ ಭೇಟಿ ನೀಡಿ ಉತ್ಪನ್ನದ ಗುಣಮಟ್ಟವನ್ನು ಪರಿಶೀಲಿಸುತ್ತಾರೆ ಮತ್ತು ಮೊದಲಿಗೆ ಸ್ವಲ್ಪ ಮೊತ್ತವನ್ನು ಮುಂಗಡವಾಗಿ ಪಾವತಿಸುತ್ತಾರೆ.
              </p>
            </div>

            <div className="faq-item">
              <div className="faq-question">
                <i className="fas fa-question-circle"></i>
                <h3>ಕನಿಷ್ಠ ಪ್ರಮಾಣ ಎಷ್ಟು ಇರಬೇಕು?</h3>
              </div>
              <p className="faq-answer">
                ನಾವು ಎಲ್ಲಾ ಪ್ರಮಾಣದ ಉತ್ಪನ್ನಗಳನ್ನು ಖರೀದಿಸುತ್ತೇವೆ. ಹೆಚ್ಚಿನ ಮಾಹಿತಿಗಾಗಿ ದಯವಿಟ್ಟು ನಮ್ಮನ್ನು ಸಂಪರ್ಕಿಸಿ.
              </p>
            </div>

            <div className="faq-item">
              <div className="faq-question">
                <i className="fas fa-question-circle"></i>
                <h3>ನಿಮ್ಮನ್ನು ಹೇಗೆ ಸಂಪರ್ಕಿಸಬಹುದು?</h3>
              </div>
              <p className="faq-answer">
                ನೀವು ನಮ್ಮನ್ನು 9902671238 ಸಂಖ್ಯೆಗೆ ಕರೆ ಮಾಡಬಹುದು ಅಥವಾ WhatsApp ಮೂಲಕ ಸಂದೇಶ ಕಳುಹಿಸಬಹುದು. ನಾವು 24/7 ಲಭ್ಯವಿದ್ದೇವೆ.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* WhatsApp Button */}
      <a
        href="https://wa.me/919902671238"
        className="whatsapp-button"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Contact on WhatsApp"
      >
        <i className="fab fa-whatsapp"></i>
      </a>
    </div>
  );
};

export default Home; 